import type { RfqSubmission } from '../types';

export function isStaffManualUploadSubmission(
  sub: Pick<RfqSubmission, 'staffManualUpload' | 'legacyImport'>,
): boolean {
  return sub.staffManualUpload === true;
}

export function isLegacyPrePortalSubmission(
  sub: Pick<RfqSubmission, 'staffManualUpload' | 'legacyImport'>,
): boolean {
  return sub.legacyImport === true && sub.staffManualUpload !== true;
}

export function staffManualUploadBadgeLabel(
  sub: Pick<RfqSubmission, 'uploadedByName'>,
): string {
  const name = sub.uploadedByName?.trim();
  return name ? `Manual upload · ${name}` : 'Manual upload';
}

export function canStaffEditQuoteSubmission(
  sub: Pick<RfqSubmission, 'staffManualUpload' | 'legacyImport' | 'id'>,
  packageId?: string | null,
): boolean {
  return !!sub.id && !!packageId && (isStaffManualUploadSubmission(sub) || isLegacyPrePortalSubmission(sub));
}

/** PM / internal staff may edit quote totals and related fields on any uploaded supplier quote. */
export function canInternalEditQuoteSubmission(
  sub: Pick<RfqSubmission, 'id' | 'notBidding' | 'storagePath' | 'quoteTotal' | 'cncQuote'>,
  packageId: string | null | undefined,
  canEditOnBehalf: boolean,
): boolean {
  if (!canEditOnBehalf || !sub.id || !packageId || sub.notBidding) return false;
  return !!(sub.storagePath || sub.quoteTotal != null || sub.cncQuote);
}
